import React, { useEffect } from 'react';
import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { loginRequest } from '../../../authConfig';
import { useNavigate } from 'react-router-dom';
import { Container } from '../../atoms/Base/Container/Container';
import { Logo } from 'components/atoms/Base/Logo/Logo';

const LoginPage = () => {
  const { instance, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const navigate = useNavigate();

  const handleLogin = () => {
    instance.loginRedirect(loginRequest);
  };

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/", { replace: true });
    }
  }, [isAuthenticated, navigate]);

  useEffect(() => {
    instance.handleRedirectPromise()
      .then((response) => {
        if (response) {
          console.log("Login success:", response);
          navigate("/", { replace: true });
        }
      })
      .catch((error) => {
        console.error("Login error:", error);
      });
  }, [instance, navigate]);

  // Show loading during authentication
  if (inProgress === "handleRedirect" || inProgress === "login") {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 flex items-center justify-center p-6">
        <Container center>
          <Container centerFull bottomSpace>
            <div className="mb-10">
              <Logo showToggleIcon={false} isLoginPage={true} />
            </div>
          </Container>
          <Container center>
            <h1 className="text-h2 text-gray-900 mb-4">Signing you in...</h1>
            <p className="text-gray-600 mb-10 text-body">Please wait while we authenticate your account</p>
            <div className="flex justify-center">
              <svg className="animate-spin h-10 w-10 text-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.25"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
            </div>
          </Container>
        </Container>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 flex items-center justify-center p-6">
      <div className="w-full max-w-lg">
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
          <div className="px-8 py-12">
            <Container centerFull bottomSpace>
              <div className="mb-8">
                <Logo showToggleIcon={false} isLoginPage={true} />
              </div>
            </Container>
            
            <div className="text-center mb-12">
              <h3 className="text-h2 text-gray-900 mb-2">Welcome to the Insights Platform</h3>
            </div>
            
            <div className="space-y-8 flex justify-center">
              <button
                type="button"
                className="w-64 flex items-center justify-center px-6 py-3 border border-transparent rounded-lg shadow-sm text-ui  text-white bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-200"
                onClick={handleLogin}
              >
                Sign in
              </button>
            </div>

            <div className="mt-10 pt-8 border-t border-gray-200">
              <div className="text-center">
                <p className="text-meta text-gray-500 mb-2">Secure authentication powered by</p>
                <p className="text-meta font-semibold text-gray-700">Microsoft</p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-8 text-center">
          <p className="text-meta text-gray-500">
            Need help? Contact your system administrator
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;